import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import Sidebar from "../components/layout/Sidebar";
import axios from "axios";
import './AboutUs.css';

// Configurazione base di axios
const getApiUrl = () => {
  // Se è definita la variabile d'ambiente, usala
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Altrimenti, usa l'URL del backend di Render
  return 'https://cogeis.onrender.com';
};

axios.defaults.baseURL = getApiUrl();
axios.defaults.withCredentials = true;

// Interceptor per le richieste
axios.interceptors.request.use(
  config => {
    console.log('Richiesta in uscita:', config);
    return config;
  },
  error => {
    console.error('Errore nella richiesta:', error);
    return Promise.reject(error);
  }
);

// Interceptor per le risposte
axios.interceptors.response.use(
  response => {
    console.log('Risposta ricevuta:', response);
    return response;
  },
  error => {
    console.error('Errore nella risposta:', error);
    return Promise.reject(error);
  }
);

const AboutUs = () => {
  const [staffMembers, setStaffMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        console.log('Inizio richiesta staff...');
        const response = await axios.get('/api/staff', {
          params: {
            limit: 100,
            page: 1,
            lang: i18n.language
          }
        });
        
        if (response.data && response.data.success) {
          console.log('Dati staff ricevuti:', response.data.data);
          setStaffMembers(response.data.data);
        } else {
          console.error('Risposta non valida:', response.data);
          setError('Errore nel formato della risposta dal server');
        }
      } catch (err) {
        console.error('Errore completo:', err);
        setError(
          err.response 
            ? `Errore ${err.response.status}: ${err.response.data.error || 'Errore nel caricamento dello staff'}`
            : 'Errore di connessione al server'
        );
      } finally {
        setLoading(false);
      }
    };

    fetchStaff();
  }, [i18n.language]);

  return (
    <>
      <Sidebar />
      <div style={{ marginLeft: "80px" }}>
        <div className="container mt-5">
          <h1 className="mb-4">{t('about.title')}</h1>
          <div className="row">
            <div className="col-md-6">
              <h5>{t('about.weAre')}</h5>
              <p>
                {t('about.weAreText')}
              </p>
              <h5>{t('about.weCreate')}</h5>
              <p>
                {t('about.weCreateText')}
              </p>
              <h5>{t('about.weCommit')}</h5>
              <p>
                {t('about.weCommitText')}
              </p>
            </div>
            <div className="col-md-6">
              <h5>{t('about.values')}</h5>
              <p>
                {t('about.valuesText')}
              </p>
              <h5 className="mt-4">{t('about.workMethod')}</h5>
              <p>
                {t('about.workMethodText')}
              </p>
            </div>
          </div>
        </div>
        <div className="container mt-5 mb-5">
          <h1 className="mb-4">Our Team</h1>
          {loading ? (
            <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Caricamento...</span>
              </div>
            </div>
          ) : error ? (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          ) : (
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
              {staffMembers.map((member) => {
                // Determina l'avatar di default basato sul genere
                const getDefaultAvatar = () => {
                  const genere = member.genere || member.gender || 'maschio';
                  if (genere === 'femmina') {
                    return '/icons/female_avatar.jpeg';
                  } else {
                    return '/icons/male_avatar.jpeg';
                  }
                };

                return (
                  <div key={member._id} className="col">
                    <div className="card h-100">
                      <div className="card-img-top-container">
                        <img 
                          src={getDefaultAvatar()} 
                          className="card-img-top" 
                          alt={`${member.nome || member.name} ${member.cognome || member.surname}`}
                          onError={(e) => {
                            e.target.src = '/icons/logo-192.png';
                          }}
                        />
                      </div>
                    <div className="card-body">
                      <h5 className="card-title">{member.nome || member.name} {member.cognome || member.surname}</h5>
                      <h6 className="card-subtitle mb-2 text-muted">{member.ruolo || member.role}</h6>
                      <p className="card-text">{member.bio || member.description}</p>
                      <div className="mt-3">
                        <p className="mb-1">
                          <i className="bi bi-envelope me-2"></i>
                          <a href={`mailto:${member.email}`} className="text-decoration-none">
                            {member.email}
                          </a>
                        </p>
                        <p className="mb-0">
                          <i className="bi bi-telephone me-2"></i>
                          <a href={`tel:${member.telefono || member.phone}`} className="text-decoration-none">
                            {member.telefono || member.phone}
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AboutUs;
